import { render, staticRenderFns } from "./TaskArchive.vue?vue&type=template&id=c5525b04&"
import script from "./TaskArchive.vue?vue&type=script&lang=js&"
export * from "./TaskArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports